import { GroupNameEnum, WebURLEnum } from '../store/authentication/types';

const isUnresolvedPlaceholder = (value?: string): boolean => {
  return typeof value === 'string' && /^#\{.+\}#$/.test(value.trim());
};

const getConfigValue = (envValue?: string, runtimeValue?: string): string => {
  if (envValue != null && envValue !== '') {
    return envValue;
  }

  if (
    runtimeValue != null &&
    runtimeValue !== '' &&
    !isUnresolvedPlaceholder(runtimeValue)
  ) {
    return runtimeValue;
  }

  return '';
};

export interface SettingsProps {
  loginWebUrl: string;
  webApiUrl: string;

  skfGroupName: string;

  [GroupNameEnum.WIND]: string;
  [GroupNameEnum.RAIL]: string;
  [GroupNameEnum.PORTAL]: string;
  [GroupNameEnum.INDUSTRY]: string;
  [GroupNameEnum.WIND_BT_PORTAL]: string;
  [GroupNameEnum.INDUSTRY_BT_PORTAL]: string;
  [GroupNameEnum.CUSTOMER_PORTAL]: string;
  [GroupNameEnum.CV4REMAN_PORTAL]: string;
  [GroupNameEnum.REMANXP_PORTAL]: string;

  groupPriority: string;

  [WebURLEnum.WIND]: string;
  [WebURLEnum.RAIL]: string;
  [WebURLEnum.PORTAL]: string;
  [WebURLEnum.INDUSTRY]: string;
  [WebURLEnum.WIND_BT_PORTAL]: string;
  [WebURLEnum.INDUSTRY_BT_PORTAL]: string;
  [WebURLEnum.CUSTOMER_PORTAL]: string;
  [WebURLEnum.CV4REMAN_PORTAL]: string;
  [WebURLEnum.REMANXP_PORTAL]: string;

  webPortalUrl: string;

  loginInstance: string;
  clientId: string;
  tenantId: string;
  signInSignOutPolicy: string;
  loginScopes: string;
  loginScopesSeparator: string;
}

export const getSettings = (): SettingsProps => {
  const environmentConfig: SettingsProps = (window as any)?.config;
  return {
    loginWebUrl: getConfigValue(
      process.env.REACT_APP_LOGIN_WEB_URL,
      environmentConfig?.loginWebUrl
    ),
    webApiUrl: getConfigValue(
      process.env.REACT_APP_WEB_API_URL,
      environmentConfig?.webApiUrl
    ),

    skfGroupName: getConfigValue(
      process.env.REACT_APP_SKF_GROUP_NAME,
      environmentConfig?.skfGroupName
    ),

    [GroupNameEnum.WIND]: getConfigValue(
      process.env.REACT_APP_WIND_GROUP_NAME,
      environmentConfig?.[GroupNameEnum.WIND]
    ),
    [GroupNameEnum.RAIL]: getConfigValue(
      process.env.REACT_APP_RAIL_GROUP_NAME,
      environmentConfig?.[GroupNameEnum.RAIL]
    ),
    [GroupNameEnum.PORTAL]: getConfigValue(
      process.env.REACT_APP_PORTAL_GROUP_NAME,
      environmentConfig?.[GroupNameEnum.PORTAL]
    ),
    [GroupNameEnum.INDUSTRY]: getConfigValue(
      process.env.REACT_APP_INDUSTRY_GROUP_NAME,
      environmentConfig?.[GroupNameEnum.INDUSTRY]
    ),
    [GroupNameEnum.WIND_BT_PORTAL]: getConfigValue(
      process.env.REACT_APP_WIND_PORTAL_GROUP_NAME,
      environmentConfig?.[GroupNameEnum.WIND_BT_PORTAL]
    ),
    [GroupNameEnum.INDUSTRY_BT_PORTAL]: getConfigValue(
      process.env.REACT_APP_INDUSTRY_PORTAL_GROUP_NAME,
      environmentConfig?.[GroupNameEnum.INDUSTRY_BT_PORTAL]
    ),
    [GroupNameEnum.CUSTOMER_PORTAL]: getConfigValue(
      process.env.REACT_APP_CUSTOMER_PORTAL_GROUP_NAME,
      environmentConfig?.[GroupNameEnum.CUSTOMER_PORTAL]
    ),
    [GroupNameEnum.CV4REMAN_PORTAL]: getConfigValue(
      process.env.REACT_APP_CV4REMAN_PORTAL_GROUP_NAME,
      environmentConfig?.[GroupNameEnum.CV4REMAN_PORTAL]
    ),
    [GroupNameEnum.REMANXP_PORTAL]: getConfigValue(
      process.env.REACT_APP_REMANXP_PORTAL_GROUP_NAME,
      environmentConfig?.[GroupNameEnum.REMANXP_PORTAL]
    ),

    groupPriority: process.env.REACT_APP_GROUP_PRIORITY
      ? JSON.parse(JSON.stringify(process.env.REACT_APP_GROUP_PRIORITY))
      : environmentConfig?.groupPriority,

    [WebURLEnum.WIND]: getConfigValue(
      process.env.REACT_APP_WIND_WEB_URL,
      environmentConfig?.[WebURLEnum.WIND]
    ),
    [WebURLEnum.RAIL]: getConfigValue(
      process.env.REACT_APP_RAIL_WEB_URL,
      environmentConfig?.[WebURLEnum.RAIL]
    ),
    [WebURLEnum.PORTAL]: getConfigValue(
      process.env.REACT_APP_PORTAL_WEB_URL,
      environmentConfig?.[WebURLEnum.PORTAL]
    ),
    [WebURLEnum.INDUSTRY]: getConfigValue(
      process.env.REACT_APP_INDUSTRY_WEB_URL,
      environmentConfig?.[WebURLEnum.INDUSTRY]
    ),
    [WebURLEnum.WIND_BT_PORTAL]: getConfigValue(
      process.env.REACT_APP_RAIL_WEB_URL,
      environmentConfig?.[WebURLEnum.RAIL]
    ),
    [WebURLEnum.INDUSTRY_BT_PORTAL]: getConfigValue(
      process.env.REACT_APP_RAIL_WEB_URL,
      environmentConfig?.[WebURLEnum.RAIL]
    ),
    [WebURLEnum.CUSTOMER_PORTAL]: getConfigValue(
      process.env.REACT_APP_CUSTOMER_PORTAL_WEB_URL,
      environmentConfig?.[WebURLEnum.CUSTOMER_PORTAL]
    ),
    [WebURLEnum.CV4REMAN_PORTAL]: getConfigValue(
      process.env.REACT_APP_CV4REMAN_PORTAL_WEB_URL,
      environmentConfig?.[WebURLEnum.CV4REMAN_PORTAL]
    ),
    [WebURLEnum.REMANXP_PORTAL]: getConfigValue(
      process.env.REACT_APP_REMANXP_PORTAL_WEB_URL,
      environmentConfig?.[WebURLEnum.REMANXP_PORTAL]
    ),

    webPortalUrl: getConfigValue(
      process.env.REACT_APP_WEB_PORTAL_URL,
      environmentConfig?.webPortalUrl
    ),

    loginInstance: getConfigValue(
      process.env.REACT_APP_LOGIN_INSTANCE,
      environmentConfig?.loginInstance
    ),
    clientId: getConfigValue(
      process.env.REACT_APP_CLIENT_ID,
      environmentConfig?.clientId
    ),
    tenantId: getConfigValue(
      process.env.REACT_APP_TENANT_ID,
      environmentConfig?.tenantId
    ),
    signInSignOutPolicy: getConfigValue(
      process.env.REACT_APP_SIGN_IN_SIGN_OUT_POLICY,
      environmentConfig?.signInSignOutPolicy
    ),
    loginScopes: getConfigValue(
      process.env.REACT_APP_LOGIN_SCOPES,
      environmentConfig?.loginScopes
    ),
    loginScopesSeparator: getConfigValue(
      process.env.REACT_APP_LOGIN_SCOPES_SEPARATOR,
      environmentConfig?.loginScopesSeparator
    ),
  };
};
